import type { FaireProductEntity } from "../../entity_types/product";

export const p_nq736gmphj: FaireProductEntity = {
  token: "p_nq736gmphj",
  type: "product",
  name: "Women's Cable Knit Crew Neck & Shorts Lounge Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/6086ffd6f568aedb51b3dfcea5cd30ab8733bd01fc81b1b91980b0aec6db3954.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6414989ab5d4735445a4191b8f8aa7ffbf5ae688fba79a26c0bb860f3617d5e3.jpeg",
    "https://cdn.faire.com/fastly/bf1e1030d3f66df503dd0f55ffbef5ff6b84a514021644c0df142348f193e340.jpeg",
    "https://cdn.faire.com/fastly/1427a60b6fdb39b943d23ee190ef194653947095dc7858b4e7b084044ea60071.png",
    "https://cdn.faire.com/fastly/d6995ee51c24598d569351cea7010689b2e955844948fc3415fa7f5064d0821e.jpeg",
    "https://cdn.faire.com/fastly/cc678fe9c60e827da7a4c8e9a1e043d25cd59421d46592293036f3de40ec695d.jpeg",
    "https://cdn.faire.com/fastly/60d9afb5032927354005cade5931810054404f94a85a93849ea2c5c540558516.jpeg",
    "https://cdn.faire.com/fastly/c8f2e052e437a4cfca0345595cee27449586b5b04f295d0bca9be721b6fca5e0.png",
    "https://cdn.faire.com/fastly/e54f14424b91da4e3f69e68cd54f622fde0de8c98cb6e09f6587e54373680f93.jpeg",
    "https://cdn.faire.com/fastly/49fce08a462c2e55f6154db867b7243efe0ae17b9f13ec1a0e4cddc1e971729f.jpeg",
    "https://cdn.faire.com/fastly/15eaed54a6c1cbc82b8483e608f6390e103898f37c679e9eafdc5b37127c1596.jpeg",
    "https://cdn.faire.com/fastly/0bde34b7e42833c1dc264f3adf3b45fad318914d9d68f26a8915227e6e9e8efa.png",
    "https://cdn.faire.com/fastly/69a53066280d1a5894d3291a8e19593e7707cfb7f91bf7a77a5995628aae8439.jpeg",
    "https://cdn.faire.com/fastly/281c7be07589612e0e094ed1b3de03585f68325a131478a42c6ea6e3cc444813.jpeg",
    "https://cdn.faire.com/fastly/9e0d436405ae91c044c26e4d2dd653620b43e6c3ed0b89c31e684b3345d34850.jpeg",
    "https://cdn.faire.com/fastly/7a150e89ad6c66f63a8b72781a44dd32a573aff11584dd0c73233e155eaf8837.png"
  ],
  priceDollars: 70,
  description: "Sink into softness that feels like a warm embrace and makes every moment of downtime a little sweeter. With its cozy texture and effortless charm, this set was made for slow mornings, quiet evenings, and everything in between.\n\nFabrication:\nMade from Softies' signature Cable Knit Marshmallow fabric, this set blends a classic cable-knit texture with an ultra-plush handfeel.\n\nFeatures:\n● Crew neckline for a timeless, easy-to-wear silhouette\n● Coordinating shorty set designed for comfort and ease\n● Cable-knit texture adds dimension and elevated style\n● 3.5\" inseam short with a drawstring waist \n\nMaterials & Care:\n● 100% Polyester\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Slow mornings and cozy evenings\n● Weekend lounging in comfort\n● Thoughtful gifting and self-care moments",
  tags: [],
  msrpDollars: 140,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:09.853Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
